import React from 'react';
import { useSpring, animated } from 'react-spring';

const Facts = () => {
    const animatedProps1 = useSpring({ number: 41, from: { number: 0 }, delay: 500 });
    const animatedProps2 = useSpring({ number: 213, from: { number: 0 }, delay: 800 });
    const animatedProps3 = useSpring({ number: 50, from: { number: 0 }, delay: 1100 });
    const animatedProps4 = useSpring({ number: 1200, from: { number: 0 }, delay: 1400 });
    const animatedProps5 = useSpring({ number: 620000, from: { number: 0 }, delay: 1700 });

    return (
        <div className="container-fluid facts py-5 pt-lg-0">
            <div className="container py-5 pt-lg-0">
                <div className="text-center wow fadeInUp mt-5" data-wow-delay="0.1s">
                    <h6 className="section-title bg-white text-center text-primary px-3">Numbers</h6>
                    <h1 className="mb-5">CNI in numbers</h1>
                </div>
                <div className="row gx-0">
                    {/* Section 1 */}
                    <div className="col-lg-4 wow zoomIn" data-wow-delay="0.1s">
                        <div className="bg-primary shadow d-flex align-items-center justify-content-center p-4" style={{ height: '150px' }}>
                            <div className="bg-white d-flex align-items-center justify-content-center rounded mb-2" style={{ width: '60px', height: '60px' }}>
                                <i className="fa fa-calendar text-primary"></i>
                            </div>
                            <div className="ps-4">
                                <h5 className="text-white mb-0">Years</h5>
                                <animated.h1 className="text-white mb-0" data-toggle="counter-up">
                                    {animatedProps1.number.interpolate((val) => Math.floor(val))}
                                </animated.h1>
                            </div>
                        </div>
                    </div>

                    {/* Section 2 */}
                    <div className="col-lg-4 wow zoomIn" data-wow-delay="0.3s">
                        <div className="bg-light shadow d-flex align-items-center justify-content-center p-4" style={{ height: '150px' }}>
                            <div className="bg-primary d-flex align-items-center justify-content-center rounded mb-2" style={{ width: '60px', height: '60px' }}>
                                <i className="fa fa-user text-white"></i>
                            </div>
                            <div className="ps-4">
                                <h5 className="text-primary mb-0">Agents</h5>
                                <animated.h1 className="mb-0" data-toggle="counter-up">
                                    {animatedProps2.number.interpolate((val) => Math.floor(val))}
                                </animated.h1>
                            </div>
                        </div>
                    </div>

                    {/* Section 3 */}
                    <div className="col-lg-4 wow zoomIn" data-wow-delay="0.6s">
                        <div className="bg-primary shadow d-flex align-items-center justify-content-center p-4" style={{ height: '150px' }}>
                            <div className="bg-white d-flex align-items-center justify-content-center rounded mb-2" style={{ width: '60px', height: '60px' }}>
                                <i className="fa fa-server text-primary"></i>
                            </div>
                            <div className="ps-4">
                                <h5 className="text-white mb-0">Servers</h5>
                                <animated.h1 className="text-white mb-0" data-toggle="counter-up">
                                    {animatedProps3.number.interpolate((val) => Math.floor(val))}
                                </animated.h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row gx-0 justify-content-center"> {/* Center the content */}
                    {/* Section 4 */}
                    <div className="col-lg-4 wow zoomIn" data-wow-delay="0.1s">
                        <div className="bg-light shadow d-flex align-items-center justify-content-center p-4" style={{ height: '150px' }}>
                            <div className="bg-primary d-flex align-items-center justify-content-center rounded mb-2" style={{ width: '60px', height: '60px' }}>
                                <i className="fa fa-building text-white"></i>
                            </div>
                            <div className="ps-4">
                                <h5 className="text-primary mb-0">Structures</h5>
                                <animated.h1 className="mb-0" data-toggle="counter-up">
                                    {animatedProps4.number.interpolate((val) => Math.floor(val))}
                                </animated.h1>
                            </div>
                        </div>
                    </div>

                    {/* Section 5 */}
                    <div className="col-lg-4 wow zoomIn" data-wow-delay="0.3s">
                        <div className="bg-primary shadow d-flex align-items-center justify-content-center p-4" style={{ height: '150px' }}>
                            <div className="bg-white d-flex align-items-center justify-content-center rounded mb-2" style={{ width: '60px', height: '60px' }}>
                                <i className="fa fa-user text-primary"></i>
                            </div>
                            <div className="ps-4">
                                <h5 className="text-white mb-0">INSAF Agents</h5>
                                <animated.h1 className="text-white mb-0" data-toggle="counter-up">
                                    {animatedProps5.number.interpolate((val) => Math.floor(val))}
                                </animated.h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Facts;
